import { StorageSelectors } from './storage.selectors';

/**
 * Interface (implemented by StorageService implementations
 * for different target platform) for saving to and reading
 * from local device storage.
 */
export abstract class StorageService {
  /**
   * Reads from the secured storage.
   * If reading fails, returns null.
   */
  public abstract readFromStorage<T>(selector: StorageSelectors): T;

  /**
   * Writes to secured storage.
   */
  public abstract setInStorage<T>(selector: StorageSelectors, value: T): void;

  /**
   * Removes stored object from secured storage.
   */
  public abstract removeFromStorage(selector: StorageSelectors): void;

  /**
   * Removes everything from the storage
   */
  public abstract clearStorage(): void;
}
